/**
 * How far the page has got with the agent on this machine.
 */
export var AgentStatus;
(function (AgentStatus) {
    /**
     * An agent answered and can inject input.
     */
    AgentStatus["Available"] = "available";
    /**
     * Discovery has not finished.
     */
    AgentStatus["Looking"] = "looking";
    /**
     * No agent is installed, or the browser will not let the page reach
     * loopback.
     */
    AgentStatus["Missing"] = "missing";
    /**
     * An agent answered but cannot inject input yet — a permission is missing.
     */
    AgentStatus["NotReady"] = "notReady";
})(AgentStatus || (AgentStatus = {}));
